// extracted by mini-css-extract-plugin
module.exports = {"statusBar":"StatusBar_statusBar__cMsvl","activeStatus":"StatusBar_activeStatus__-6uGI","completedStatusIcon":"StatusBar_completedStatusIcon__3ao9p"};